import React from 'react';
import { ProviderParams } from '../models/react';
import { GSSUserInfo, UserContextType, UserDefaultType } from '../models/user';
import mockLocalstorage from '../mocks/localstorage.json';
import { EnvironmentConfig } from '../models/environment';
import useConfig from '../hooks/config.hook';
import { getLanguageByString } from '../models/language';

declare const userInfo: string;
const UserContext = React.createContext<UserContextType | undefined>(undefined);
export function useUserContext() {
  return React.useContext(UserContext);
}

const getPageLocale = ():string=>{
    try{
      const userInfoJson = JSON.parse(userInfo) as GSSUserInfo
      return userInfoJson.locale
    }catch(e){
      return ""
    }
}

export default function UserProvider({ children }: ProviderParams) {

  const config = useConfig();

  function getUserInfo (): UserDefaultType | undefined {
    if (config?.auth.local_storage_var_name === "") return undefined
    const cookie = localStorage.getItem(config.auth.local_storage_var_name)
    // // ToDo: remove fallback
    console.log("recovered: ", cookie)
    const ringUser = cookie ? JSON.parse(cookie) : mockLocalstorage;

    const resp: UserDefaultType = {
      ...ringUser?.value,
      companyId: getValue(ringUser, config.auth.company_id_path || ''),
      emailId: getValue(ringUser, config.auth.email_id_path || ''),
      firstName: getValue(ringUser, config.auth.first_name_path || ''),
      lastName: getValue(ringUser, config.auth.last_name_path || ''),
      userId: getValue(ringUser, config.auth.user_id_path || ''),
      accessToken: getValue(ringUser, config.auth.access_token_path || ''), 
      phoneNumber: getValue(ringUser, config.auth.phone_number_path || ''),
      userRole: getValue(ringUser, config.auth.user_role_path || ''),
      userType: getValue(ringUser, config.auth.user_type_path || ''),
      location: getValue(ringUser, config.auth.user_location_path || ''),
      default_language: 'en_us'
    }
  
    const locale = getPageLocale() || getValue(ringUser, config.auth.user_locale_path || '')
    if (locale) {
      resp.locale = locale
      const language = getLanguageByString(locale)
      if(language) {
        resp.default_language = language?.languageCode
      }
    }

    return resp;
  }
  
  // // if (config?.auth.local_storage_var_name === "") return undefined
  // let cookie = useLocalStorage(config.auth.local_storage_var_name)
  // const [userInfo, setUserInfo] = React.useState(getStorage(config, cookie || "{}"));

  // async function updateUserInfo (){
  //   const items = getStorage(config, cookie || "{}");
  //   if (items) {
  //     setUserInfo(items);
  //    }
  // }

  return (
    <UserContext.Provider value={{ getUserInfo }}>
      {children}
    </UserContext.Provider>
  );
}

function getValue(obj: any, path: string) {
  const keys = path.split(".");
  let current = obj;
  for (const key of keys) {
    if (typeof current === 'object' && current !== null && key in current) {
      current = current[key];
    } else {
      return "";
    }
  }
  return current;
}

function getStorage(config: EnvironmentConfig, cookie: string): UserContextType | undefined {

  // if (config?.auth.local_storage_var_name === "") return undefined

  // // const cookie = localStorage.getItem(config.auth.local_storage_var_name)
  // const cookie = useLocalStorage(config.auth.local_storage_var_name).getItem() || "{}"
  // // ToDo: remove fallback
  const ringUser = cookie ? JSON.parse(cookie) : mockLocalstorage;

  const resp: UserContextType = {
    ...ringUser?.value,
    companyId: getValue(ringUser, config.auth.company_id_path || ''),
    emailId: getValue(ringUser, config.auth.email_id_path || ''),
    firstName: getValue(ringUser, config.auth.first_name_path || ''),
    lastName: getValue(ringUser, config.auth.last_name_path || ''),
    userId: getValue(ringUser, config.auth.user_id_path || ''),
    accessToken: getValue(ringUser, config.auth.access_token_path || ''), // Add accessToken 
    phoneNumber: getValue(ringUser, config.auth.phone_number_path || ''),
    userRole: getValue(ringUser, config.auth.user_role_path || ''),
    userType: getValue(ringUser, config.auth.user_type_path || ''),
  }

  return resp;
}